<div class="auth-container">
  <div class="auth-background">
    <div class="background-pattern"></div>
  </div>

  <div class="auth-content">
    <div class="auth-card">
      <div class="auth-header">
        <div class="app-logo">
          <img
            class="logo-img"
            src="assets/reball/reball logo no bg.png"
            alt="ReBall"
          />
          <h1 class="app-title">ReBall</h1>
        </div>
        <div class="logout-icon">
          <lucide-icon name="hand" [size]="32"></lucide-icon>
        </div>
        <h2 class="auth-title">See You Soon!</h2>
        <p class="auth-subtitle">You have been successfully logged out</p>
      </div>

      <div class="logout-actions">
        <button (click)="navigateToLogin()" class="auth-button primary">
          Sign In Again
        </button>

        <div class="auth-divider">
          <span>or</span>
        </div>

        <button (click)="navigateToRegister()" class="auth-button secondary">
          Create New Account
        </button>
      </div>

      <div class="logout-message">
        <p>Thank you for using ReBall. Your session has been securely ended.</p>
      </div>
    </div>
  </div>
</div>
